module.exports = __webpack_public_path__ + "static/media/backgroundMobile-signUp.6e396f8f.png";